import { render, staticRenderFns } from "./FolderList.vue?vue&type=template&id=62207568&scoped=true&"
import script from "./FolderList.vue?vue&type=script&lang=ts&"
export * from "./FolderList.vue?vue&type=script&lang=ts&"
import style0 from "./FolderList.vue?vue&type=style&index=0&id=62207568&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62207568",
  null
  
)

export default component.exports